import FN from '@/utility/fn'
import md5 from 'md5'
import configUrl from '@/utility/config'
const VERSION = '1.2'

let saveEquipmentCode = () => {
  return new Promise((resolve, reject) => {
    let code = FN.getLocal('equipment')
    if (code === undefined || JSON.stringify(code) === '{}' || code == '') {
      let equipment = FN.getURLparams().openid ? md5(FN.getURLparams().openid) :
        FN.getURLparams().utma ? FN.getURLparams().utma :
          FN.getURLparams().idfa ? FN.getURLparams().idfa :
            JSON.stringify(FN.getLocal('utma')) !== '{}' ? FN.getLocal('utma') :
              md5(FN.uuid()) // 手机IMEI/IDFA
      if (equipment == '9f89c84a559f573636a47ff8daed0d33' || equipment == '00000000-0000-0000-0000-000000000000') {
        equipment = md5(FN.uuid())
      }
      FN.saveLocal('equipment', equipment)
      let callback = {
        code: 0
      }
      setTimeout(function () {
        resolve(callback)
      }, 100)
    } else {
      let callback = {
        code: 0
      }
      setTimeout(function () {
        resolve(callback)
      }, 100)
    }
  })
}
saveEquipmentCode()
let getGlobalHeader = () => {
  let h5sdk = FN.getLocal('h5sdk')
  let h5sdk2 = FN.getLocal('h5sdk')
  let local = window.FUSE_CHANNEL_INFO
  // let package_id = window.FUSE_CHANNEL_INFO.package_id
  // let package_id = window.FUSE_INIT_INFO.package_id
  let cookie_uuid = FN.getURLparams().openid ? md5(FN.getURLparams().openid) : FN.getURLparams().utma ? FN.getURLparams().utma : h5sdk['cookie_uuid'] ? h5sdk['cookie_uuid'] : h5sdk2['cookie_uuid'] ? h5sdk2['cookie_uuid'] : FN.getLocal('uuid')
  return {
    is_jsdk: 1,
    cookie_uuid: cookie_uuid
  }
}
const setDeviceInfo = (data) => {
  data['imei'] = FN.getURLparams().openid ? md5(FN.getURLparams().openid) : FN.getURLparams().utma ? FN.getURLparams().utma : FN.getURLparams().idfa ? FN.getURLparams().idfa : JSON.stringify(FN.getLocal('utma')) !== '{}' ? FN.getLocal('utma') : FN.getLocal('equipment') // 手机IMEI/IDFA
  data['mac'] = FN.getURLparams().openid ? md5(FN.getURLparams().openid) : FN.getURLparams().utma ? FN.getURLparams().utma : FN.getURLparams().idfa ? FN.getURLparams().idfa : JSON.stringify(FN.getLocal('utma')) !== '{}' ? FN.getLocal('utma') : FN.getLocal('equipment') // 手机mac网卡地址
  data['utma'] = FN.getURLparams().utma ? FN.getURLparams().utma : JSON.stringify(FN.getLocal('utma')) !== '{}' ? FN.getLocal('utma') : FN.getLocal('equipment') // 设备标识
  if (data['utma'] == '9f89c84a559f573636a47ff8daed0d33' || data['utma'] == '00000000-0000-0000-0000-000000000000') {
    data['utma'] = FN.getLocal('equipment')
  }
  if (data['imei'] == '00000000-0000-0000-0000-000000000000') {
    data['imei'] = JSON.stringify(FN.getLocal('utma')) !== '{}' ? FN.getLocal('utma') : FN.getLocal('equipment')
  }
}

const setGameInfo = (data) => {
  data['channel'] =  window.FUSE_CHANNEL_INFO.channel
  data['game_id'] = window.FUSE_CHANNEL_INFO.game_id
  data['pf_game_id'] = window.FUSE_CHANNEL_INFO.pf_game_id
  data['game_name'] = window.FUSE_CHANNEL_INFO.game_name
  data['package_id'] = window.FUSE_INIT_INFO ?  window.FUSE_INIT_INFO.package_id || window.FUSE_CHANNEL_INFO.package_id : window.FUSE_CHANNEL_INFO.package_id // fuse 默认为 0
  data['tf_planid'] = FN.getURLparams().tf_planid || window.FUSE_INIT_INFO?.tf_planid || localStorage.getItem('tf_planid_' + window.FUSE_CHANNEL_INFO.pf_game_id) || ''
  data['tf_pfname'] = window.FUSE_INIT_INFO ? window.FUSE_INIT_INFO.tf_pfname || 'web_view' : 'web_view'
}

let extFooter = {
  model: '', // 手机机型
  caid: JSON.stringify(FN.getLocal('caid')) !== '{}' ? FN.getLocal('caid') : '', // ios的caid
  screen: window.screen.width + 'x' + window.screen.height,

  // os: setTimeout(function () { return window.FUSE_CHANNEL_INFO.os }, 1), // 手机系统1、android；2、越狱ios；3、其他；4、正版ios
  os_version: '', // 系统版本号

  simulator: '0', // 是否模拟器，0不是；1是
  isroot: 0, // 是否root/越狱，0不是1是
  serial_number: '', // 设备序列号
  imsi: '', // 手机卡的编号
  android_id: '', // 设备标识 ANDROID_iD

  net: 4, // 手机网络1、2G；2、3G；3、wifi；4、其他
  operators: 4, // 运营商 1、移动；2、联通；3、电信；4、其他
  location: '', // 地址位置

  version: VERSION, // 必填融合SDK版本号
  game_version: '1.0', // 必填游戏版本号
  platform_version: '1.0', // 必填渠道版本号
  server_version: '1.2' // 服务端版本号
}

setDeviceInfo(extFooter)

let userBaseMsg = {
  user_id: '', // 必填用户id
  phone: '', // 用户电话号码
  is_bind_phone: 0, // 是否绑定手机号码  1 是  0 不是
  is_realname: 0 // 是否实名    1 是  0 不是
}

let roleBaseConfig = {
  server_id: '1', // 必填服务器ID
  server_name: '1', // 必填服务器名称
  role_id: '1000', // 必填角色id
  role_name: '1', // 必填角色名称
  role_level: '1', // 必填角色等级
  balance: '1', // 必填游戏币余额
  vip_level: '0' // 必填vip等级
}

let roleBaseMsg = {
  ...roleBaseConfig,
  balance: '1', // 必填游戏币余额
  vip_level: '1', // 必填VIP等级
  guild_name: '', // 公会名称
  guild_id: '', // 公会id
  fighting: '' // 战力
}



window.MJFUSESDK = {
  init(params = {}) {
    FN.log('opendid的参数初始化')
    let input = {
      ct: 'init',
      ac: 'index',
      ...getGlobalHeader(),
      ...extFooter,
      ...params,
      channel: window.FUSE_CHANNEL_INFO.channel,
      game_id: window.FUSE_CHANNEL_INFO.game_id,
      pf_game_id: window.FUSE_CHANNEL_INFO.pf_game_id,
      game_name: window.FUSE_CHANNEL_INFO.game_name,
      package_id: window.FUSE_CHANNEL_INFO.package_id, // fuse 默认为 0
      os: window.FUSE_CHANNEL_INFO.os,
      tf_planid: FN.getURLparams().tf_planid || localStorage.getItem('tf_planid_' + window.FUSE_CHANNEL_INFO.pf_game_id),
      model: '', // 手机机型
      caid: JSON.stringify(FN.getLocal('caid')) !== '{}' ? FN.getLocal('caid') : '' // ios的caid
    }
    setDeviceInfo(input)
    return FN.fuseSdkAjax('fuse:init', input, {
      domain: configUrl.__fuseDomain.get('init')
    })
  },
  login(params = {}) {
    let input = {
      ct: 'user',
      ac: 'login',
      ...getGlobalHeader(),

      ext: {}, // 额外渠道参数：

      data: {}, // 大部分渠道都会有特殊参数要传
      user_id: '', // 从客户端获取的用户id,方便排查问题。比如步步高
      phone: '', // 用户电话号码
      is_bind_phone: 0, // 是否绑定手机号码  1 是  0 不是
      is_realname: 0, // 是否实名    1 是  0 不是
      ...extFooter,
      ...params,
      os: window.FUSE_CHANNEL_INFO.os,
      model: '', // 手机机型
      caid: JSON.stringify(FN.getLocal('caid')) !== '{}' ? FN.getLocal('caid') : '' // ios的caid
    }
    setGameInfo(input)
    setDeviceInfo(input)
    return FN.fuseSdkAjax('fuse:login', input, {
      domain: configUrl.__fuseDomain.get('user')
    })
  },
  makeOrder(params = {}) {
    console.log('window.FUSE_CHANNEL_INFO', window.FUSE_CHANNEL_INFO)
    let input = {
      ct: 'pay',
      ac: 'make_order',
      ...getGlobalHeader(),
      ...roleBaseConfig,
      user_id: '', // 必填用户id
      amount: '', // 必填充值金额，单位：分
      notify_url: '', // 必填CP通知URL
      callback_info: '', // CP回调参数
      ext: '', // 额外渠道参数：  对象json化
      ...extFooter,
      ...params,
      os: window.FUSE_CHANNEL_INFO.os,
      model: '', // 手机机型
      caid: JSON.stringify(FN.getLocal('caid')) !== '{}' ? FN.getLocal('caid') : '' // ios的caid
    }
    setGameInfo(input)
    setDeviceInfo(input)
    return FN.fuseSdkAjax('fuse:makeOrder', input, {
      domain: configUrl.__fuseDomain.get('pay')
    })
  },
  roleAdd(params = {}) {
    let input = {
      ct: 'role',
      ac: 'add',
      ...getGlobalHeader(),
      ...userBaseMsg,
      ...roleBaseMsg,
      ...extFooter,
      ...params,
      os: window.FUSE_CHANNEL_INFO.os,
      model: '', // 手机机型
      caid: JSON.stringify(FN.getLocal('caid')) !== '{}' ? FN.getLocal('caid') : '' // ios的caid
    }
    setGameInfo(input)
    setDeviceInfo(input)
    return FN.fuseSdkAjax('fuse:roleAdd', input, {
      domain: configUrl.__fuseDomain.get('role')
    })
  },
  roleLogin(params = {}) {
    let input = {
      ct: 'role',
      ac: 'login',
      ...getGlobalHeader(),
      ...userBaseMsg,
      ...roleBaseMsg,
      ...extFooter,
      ...params,
      os: window.FUSE_CHANNEL_INFO.os,
      model: '', // 手机机型
      caid: JSON.stringify(FN.getLocal('caid')) !== '{}' ? FN.getLocal('caid') : '' // ios的caid
    }
    setGameInfo(input)
    setDeviceInfo(input)
    return FN.fuseSdkAjax('fuse:roleLogin', input, {
      domain: configUrl.__fuseDomain.get('role')
    })
  },
  roleLevel(params = {}) {
    let input = {
      ct: 'role',
      ac: 'level',
      ...getGlobalHeader(),
      ...userBaseMsg,
      ...roleBaseMsg,
      ...extFooter,
      ...params,
      os: window.FUSE_CHANNEL_INFO.os,
      model: '', // 手机机型
      caid: JSON.stringify(FN.getLocal('caid')) !== '{}' ? FN.getLocal('caid') : '' // ios的caid
    }
    setGameInfo(input)
    setDeviceInfo(input)
    return FN.fuseSdkAjax('fuse:roleLevel', input, {
      domain: configUrl.__fuseDomain.get('role')
    })
  },
  checkBindPhone(params = {}) {
    let input = {
      ct: 'user',
      ac: 'check_bind_phone',
      ...getGlobalHeader(),
      ...extFooter,
      ...params,
      os: window.FUSE_CHANNEL_INFO.os,
      model: '', // 手机机型
      caid: JSON.stringify(FN.getLocal('caid')) !== '{}' ? FN.getLocal('caid') : '' // ios的caid
    }
    setGameInfo(input)
    setDeviceInfo(input)
    return FN.fuseSdkAjax('fuse:checkBindPhone', input, {
      domain: configUrl.__fuseDomain.get('user')
    })
  },
  bindPhone(params = {}) {
    let guid = FN.getLocal('FUSE_USER_INFO').guid
    let KEY = String(new Date().getTime()).substr(0, 10)
    let obj = {
      ...getGlobalHeader(),
      //   guid: 1221, // 必填用户的guid，登录验证接口有返回
      ...extFooter,
      ...params,
      guid,
      os: window.FUSE_CHANNEL_INFO.os,
      // is_jsdk: 1
    }
    setGameInfo(obj)
    setDeviceInfo(obj)
    let c = FN.requestEncrypt(JSON.stringify(obj), KEY).e
    let search = FN.Obj2URL({
      ct: 'user',
      ac: 'bind_phone',
      p: c,
      ts: KEY,
      is_jsdk: 1
    })
    return configUrl.__fuseDomain.get('user') + '?' + search
  },
  h5pub(params = {}) {
    // 这个函数主要用来请求秘钥之类的,例如星云渠道
    let input = {
      ct: 'init',
      ac: 'h5pub',
      is_jsdk: 1,
      ...getGlobalHeader(),
      ...extFooter,
      os: window.FUSE_CHANNEL_INFO.os,
      ...params,
      model: '', // 手机机型
      caid: JSON.stringify(FN.getLocal('caid')) !== '{}' ? FN.getLocal('caid') : '' // ios的caid
    }
    setGameInfo(input)
    setDeviceInfo(input)
    return FN.fuseSdkAjax('fuse:h5pub', input, {
      domain: configUrl.__fuseDomain.get('init')
    })
  },
  someData(params = {}) {
    let input = {
      ct: 'init',
      ac: 'index',
      ...getGlobalHeader(),
      ...extFooter,
      ...params,
      os: window.FUSE_CHANNEL_INFO.os,
      model: '', // 手机机型
      caid: JSON.stringify(FN.getLocal('caid')) !== '{}' ? FN.getLocal('caid') : '' // ios的caid
    }
    setGameInfo(input)
    setDeviceInfo(input)
    return FN.fuseSdkAjax('fuse:init', input, {
      domain: configUrl.__fuseDomain.get('init')
    })
  },
  spread(params = {}) {
    let input = {
      ct: 'spread',
      ac: 'index',
      ...getGlobalHeader(),
      ...extFooter,
      ...params,
      os: window.FUSE_CHANNEL_INFO.os,
      model: '', // 手机机型
      caid: JSON.stringify(FN.getLocal('caid')) !== '{}' ? FN.getLocal('caid') : '' // ios的caid
    }
    setGameInfo(input)
    setDeviceInfo(input)
    return FN.fuseSdkAjax('fuse:spread', input, {
      domain: configUrl.__fuseDomain.get('init')
    })
  },
  getRoleList(params = {}) {
    let input = {
      ct: 'role',
      ac: 'get_role_list',
      ...getGlobalHeader(),
      ...extFooter,
      ...params,
      os: window.FUSE_CHANNEL_INFO.os,
      user_id: FN.getLocal('USER_INFO').old_id,
      model: '', // 手机机型
      caid: JSON.stringify(FN.getLocal('caid')) !== '{}' ? FN.getLocal('caid') : '' // ios的caid
    }
    setGameInfo(input)
    setDeviceInfo(input)
    return FN.fuseSdkAjax('fuse:getRoleList', input, {
      domain: configUrl.__fuseDomain.get('role')
    })
  },
  getSetting(params = {}) {
    let input = {
      ct: 'api_url',
      ac: 'get_setting',
      ...getGlobalHeader(),
      ...extFooter,
      ...params,
      os: window.FUSE_CHANNEL_INFO.os,
      user_id: FN.getLocal('USER_INFO').old_id,
      model: '', // 手机机型
      caid: JSON.stringify(FN.getLocal('caid')) !== '{}' ? FN.getLocal('caid') : '' // ios的caid
    }
    setGameInfo(input)
    setDeviceInfo(input)
    return FN.fuseSdkAjax('fuse:getSetting', input, {
      domain: configUrl.__fuseDomain.get('user')
    })
  },
  // 获取打点配置-海外
  getBuryingConfig(params = {}) {
    let input = {
      ct: 'sdk',
      ac: 'burying_config',
      ...getGlobalHeader(),
      ...userBaseMsg,
      ...roleBaseMsg,
      ...extFooter,
      ...params,
      os: window.FUSE_CHANNEL_INFO.os,
      user_id: FN.getLocal('USER_INFO').old_id,
      model: '', // 手机机型
      caid: JSON.stringify(FN.getLocal('caid')) !== '{}' ? FN.getLocal('caid') : '' // ios的caid
    }
    setGameInfo(input)
    setDeviceInfo(input)
    return FN.fuseSdkAjax('fuse:burying_config', input, {
      domain: configUrl.__fuseDomain.get('user')
    })
  },
  // 查询订单结果
  checkOrderStatus(params) {
    let input = {
      ct: 'order',
      ac: 'check_h5',
      ...getGlobalHeader(),
      ...extFooter,
      ...params,
      os: window.FUSE_CHANNEL_INFO.os,
      model: '', // 手机机型
      caid: JSON.stringify(FN.getLocal('caid')) !== '{}' ? FN.getLocal('caid') : '', // ios的caid
      js: 1
    }
    setGameInfo(input)
    setDeviceInfo(input)
    return FN.fuseSdkAjax('fuse:makeOrder', input, {
      domain: configUrl.__fuseDomain.get('pay')
    })
  }
}

const getData =() =>{
  var userinfo = FN.getSession('USER_INFO');
  var sdkInitInfo = FN.getSession('SDK_INIT_INFO');
  var fusionChannelInfo = FN.getSession('FUSE_CHANNEL_INFO');
  let user_info = {}
  let fuse_channel_info = {}
  let init_info = {}
  user_info['user_id'] =userinfo.user_id
  user_info['name'] =userinfo.name
  user_info['phone'] =userinfo.phone
  user_info['email'] =userinfo.email
  user_info['password'] =userinfo.password
  user_info['charge_limit'] =userinfo.charge_limit
  user_info['real_name_status'] =userinfo.real_name_status
  user_info['login_real_name_cfg'] =userinfo.login_real_name_cfg
  user_info['charge_limit_view_cfg'] =userinfo.charge_limit_view_cfg
  user_info['age'] =userinfo.age
  user_info['user_type'] = userinfo.login_type
  user_info['is_bind'] = userinfo.is_bind
  init_info['hongbao'] = sdkInitInfo.hongbao
  init_info['overseas'] = true
  init_info['area_code'] = navigator.language
  init_info['system_language'] = navigator.language
  fuse_channel_info['channel'] = fusionChannelInfo.channel
  fuse_channel_info['channel_id'] = fusionChannelInfo.channel_id
  fuse_channel_info['game_id'] = fusionChannelInfo.pf_game_id
  fuse_channel_info['pf_game_id'] = fusionChannelInfo.pf_game_id
  fuse_channel_info['package_id'] = fusionChannelInfo.package_id
  let data = {
    fuse_channel_info,
    user_info,
    init_info,
    ext_footer:{...extFooter},
    isjs: 1
  }
  return data;
}


export default {
  getData,
}